package one.healthium.onboarding.domain.configs


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.PlatformValueSerializer

@Serializable
@SerialName("notifications_access")
data class NotificationsAccessScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("cta_cancel_title") val ctaCancelTitle: String? = null,
    @SerialName("notification") val notification: Notification? = null,
) : ScreenConfig

@Serializable
data class Notification(
    @SerialName("app_icon") @Serializable(with = PlatformValueSerializer::class) val appIcon: String? = null,
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
)